module.exports = __webpack_public_path__ + "static/media/rules-puzzle-halfway.8dec8a90.png";